// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import {
    useQuery
} from '@tanstack/react-query';

import bksAPI from 'api/bks';
import crowdCountingAPI from '../../api/crowd_counting';

import { useAuth0 } from "@auth0/auth0-react";
import { useLocation, useMatch, useNavigate } from 'react-router-dom';

import { createTheme, Grid, Slider, styled, Tab, Tabs, useTheme } from "@mui/material";
import moment from "moment";
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from "react";

import { CalendarMonth, Circle, PlayCircle, ShowChart } from "@mui/icons-material";
import HeatMap from "nextus/Maps/HeatMap";

import CrowdCountingChart from "nextus/Charts/CrowdCountingChart";

import process from "../../api/process";
import CustomTabPanel from "../../components/CustomTabPanel";
import UpdateDateTime from "../../components/UpdateDateTime";
import TransportTab from "../../components/TransportTab";
import GeneralTab from "../../components/GeneralTab";
import LiveTab from "../../components/LiveTab";
import Playback from "../../components/Playback";

import MainView from "../../components/MainView";
import EventList from "../../components/EventList";


// import ObjModel from "nextus/Models/ObjModel";

function wrapper(content) {
    return (
        <SoftBox p={3}
            sx={({ palette: { white }, boxShadows: { navbarBoxShadow }, borders: { borderRadius }, functions: { rgba, pxToRem } }) => ({
                boxShadow: navbarBoxShadow,
                backdropFilter: `saturate(200%) blur(${pxToRem(4)})`,
                // backgroundColor: rgba(white.main, 0.8),
                borderRadius: borderRadius.xl,
                height: 'calc(100% - 50px)',
                overflowY: 'auto',
                '::-webkit-scrollbar': {
                    backgroundColor: 'transparent',
                    width: '8px',
                },
                '::-webkit-scrollbar-track': { /* background of the scrollbar except button or resizer */
                    backgroundColor: 'transparent',
                },
                '::-webkit-scrollbar-thumb': { /* scrollbar itself */
                    backgroundColor: '#babac0',
                    borderRadius: '6px',
                    border: `1px solid ${rgba(white.main, 0.8)}`,
                },
                '::-webkit-scrollbar-button': { /* set button(top and bottom of the scrollbar) */
                    display: 'none',
                },
            })}
        >
            {content}
        </SoftBox>
    );
}




function CrowdCountingEventList({ map, navTitle, setNavTitle, sidebarState, setSidebarState }) {


    const single_page = useMatch('/crowds/:event_id/:uuid');
    const navigate = useNavigate();

    const { state } = useLocation(); //page reloads after using this data, so it becomes null

    useEffect(() => {
        setSidebarState('sidenav');
        setNavTitle(['crowd counting']);

    }, [sidebarState, navTitle]);

    const { user } = useAuth0();

    crowdCountingAPI.loadToken(useAuth0());

    const events = useQuery({
        queryKey: ['getCameraEvents'],
        queryFn: async () => {
            return crowdCountingAPI.getCameraEvents()
        }
    });

    function openSelectedEvent(event) {
        console.log(event)
        let path = '/crowds/' + event._id;
        navigate(path);
    }

    function editSelectedEvent(event) {
        console.log(event)
        let path = '/crowds/' + event._id + '/edit';
        navigate(path);
    }

    let events_data = [];

    if (events.data) {
        events_data = events.data;
    }

    return (
        wrapper(
            <SoftBox sx={{ height: 'calc(100% + 24px)' }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sx={{ transition: 'all 0.7s ease-in-out' }}>
                        <EventList events={events_data} editSelectedEvent={editSelectedEvent} openSelectedEvent={openSelectedEvent} />
                    </Grid >
                </Grid >
            </SoftBox >
        )
    );
}

CrowdCountingEventList.propTypes = {
    map: PropTypes.object,
    navTitle: PropTypes.array,
    setNavTitle: PropTypes.func,
    sidebarState: PropTypes.string,
    setSidebarState: PropTypes.func,
}

export default CrowdCountingEventList;
